import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const ICONES = ['🚗', '🏍️', '🚛', '🚐', '🚌', '⛵', '🚜', '🚑', '🚒', '🚕', '🚚', '🚲', '🛴'];
const TIPOS = ['Veículo de Passeio', 'Moto', 'Caminhão', 'Van', 'Ônibus', 'Barco', 'Trator', 'Máquina', 'Ambulância', 'Cavalo Mecânico', 'Carreta', 'Bicicleta', 'Patinete'];
const CORES = ['#1D9E75', '#2563EB', '#DC2626', '#D97706', '#7C3AED', '#DB2777', '#0891B2', '#111827'];

function exportarTargetsPDF(lista, tituloFiltro) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Veículos</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Veículos ${tituloFiltro ? `— ${tituloFiltro}` : ''}</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — ${lista.length} veículo${lista.length !== 1 ? 's' : ''} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Placa</th><th>Nome</th><th>Tipo</th><th>Cliente</th><th>Serial Equipamento</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${lista.map(t => `
            <tr>
              <td>${t.identificador || '—'}</td>
              <td>${t.nome || '—'}</td>
              <td>${t.tipo || '—'}</td>
              <td>${t.cliente_nome || '—'}</td>
              <td>${t.equipamento_serial || '—'}</td>
              <td>${t.status === 'ativo' ? 'Ativo' : 'Inativo'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarTargetsCSV(lista) {
  const linhas = [
    'Placa,Nome,Tipo,Cliente,Serial Equipamento,Status',
    ...lista.map(t => {
      const campos = [t.identificador, t.nome, t.tipo, t.cliente_nome, t.equipamento_serial, t.status === 'ativo' ? 'Ativo' : 'Inativo'];
      return campos.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(',');
    })
  ];
  const blob = new Blob([String.fromCharCode(0xFEFF) + linhas.join(String.fromCharCode(10))], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `veiculos_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
}

function Targets() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [targets, setTargets] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [equipamentos, setEquipamentos] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [targetSelecionado, setTargetSelecionado] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const [form, setForm] = useState({
    identificador: '', nome: '', modelo: '', tipo: 'Veículo de Passeio',
    icone: '🚗', cor: '#1D9E75', cliente_id: '', equipamento_id: '', observacoes: ''
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarTargets();
    carregarClientes();
    carregarEquipamentos();
  }, []);

  const carregarTargets = async () => {
    try {
      const res = await axios.get(`${API}/targets`, { headers });
      setTargets(res.data);
    } catch (err) { console.error(err); }
  };

  const carregarClientes = async () => {
    try {
      const res = await axios.get(`${API}/clientes`, { headers });
      setClientes(res.data);
    } catch (err) { console.error(err); }
  };

  const carregarEquipamentos = async () => {
    try {
      const res = await axios.get(`${API}/equipamentos`, { headers });
      setEquipamentos(res.data);
    } catch (err) { console.error(err); }
  };

  const salvar = async () => {
    if (!form.identificador) return alert('Identificador (placa) é obrigatório!');
    if (!form.nome) return alert('Nome do veículo é obrigatório!');
    setSalvando(true);
    try {
      if (targetSelecionado) {
        await axios.put(`${API}/targets/${targetSelecionado.id}`, form, { headers });
      } else {
        await axios.post(`${API}/targets`, form, { headers });
      }
      fecharModal();
      carregarTargets();
    } catch (err) { alert('Erro ao salvar. Identificador já cadastrado?'); }
    setSalvando(false);
  };

  const editar = (target) => {
    setTargetSelecionado(target);
    setForm({
      identificador: target.identificador || '',
      nome: target.nome || '',
      modelo: target.modelo || '',
      tipo: target.tipo || 'Veículo de Passeio',
      icone: target.icone || '🚗',
      cor: target.cor || '#1D9E75',
      cliente_id: target.cliente_id || '',
      equipamento_id: target.equipamento_id || '',
      observacoes: target.observacoes || ''
    });
    setModalAberto(true);
  };

  const inativar = async (target) => {
    const acao = target.status === 'ativo' ? 'inativar' : 'reativar';
    if (!window.confirm(`Deseja ${acao} o veículo ${target.identificador}?`)) return;
    try {
      if (target.status === 'ativo') {
        await axios.patch(`${API}/targets/${target.id}/inativar`, {}, { headers });
      } else {
        await axios.put(`${API}/targets/${target.id}`, { ...target, status: 'ativo' }, { headers });
      }
      carregarTargets();
    } catch (err) { alert('Erro ao alterar status'); }
  };

  const deletar = async (target) => {
    if (!window.confirm(`ATENÇÃO: Isso vai remover permanentemente o veículo ${target.identificador} e todo o histórico de posições. Confirma?`)) return;
    if (!window.confirm(`Segunda confirmação: Tem certeza? Esta ação não pode ser desfeita!`)) return;
    try {
      await axios.delete(`${API}/targets/${target.id}`, { headers });
      carregarTargets();
    } catch (err) { alert('Erro ao remover veículo'); }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setTargetSelecionado(null);
    setForm({ identificador: '', nome: '', modelo: '', tipo: 'Veículo de Passeio', icone: '🚗', cor: '#1D9E75', cliente_id: '', equipamento_id: '', observacoes: '' });
  };

  // Equipamentos já vinculados a outros targets (exceto o atual em edição)
  const equipamentosVinculados = targets
    .filter(t => t.equipamento_id && (!targetSelecionado || t.id !== targetSelecionado.id))
    .map(t => t.equipamento_id);
  const equipamentosDisponiveis = equipamentos.filter(e => !equipamentosVinculados.includes(e.id));

  const targetsFiltrados = targets.filter(t => {
    const matchBusca = !busca ||
      t.identificador?.toLowerCase().includes(busca.toLowerCase()) ||
      t.nome?.toLowerCase().includes(busca.toLowerCase()) ||
      t.modelo?.toLowerCase().includes(busca.toLowerCase()) ||
      t.cliente_nome?.toLowerCase().includes(busca.toLowerCase()) ||
      t.equipamento_serial?.toLowerCase().includes(busca.toLowerCase()) ||
      t.equipamento_modelo?.toLowerCase().includes(busca.toLowerCase());
    const matchStatus = filtroStatus === 'todos' || t.status === filtroStatus;
    return matchBusca && matchStatus;
  });

  const totalAtivos = targets.filter(t => t.status === 'ativo').length;
  const totalInativos = targets.filter(t => t.status === 'inativo').length;
  const totalOnline = targets.filter(t => t.ultima_atualizacao && (new Date() - new Date(t.ultima_atualizacao)) < 5 * 60 * 1000).length;

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', alignItems: 'center', gap: '16px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🚗 Targets / Veículos</span>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>({targets.length} cadastrados)</span>
      </div>

      <div style={{ paddingTop: '80px', padding: '80px 24px 24px' }}>

        {/* Contadores */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #1D9E75' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#1D9E75' }}>{targets.length}</div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>Total de veículos</div>
          </div>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #22C55E' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#22C55E' }}>{totalAtivos}</div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>🟢 Ativos</div>
          </div>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #3B82F6' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#3B82F6' }}>{totalOnline}</div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>📡 Online agora</div>
          </div>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #9CA3AF' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#9CA3AF' }}>{totalInativos}</div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>⚪ Inativos</div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px' }}>
          <div style={{ display: 'flex', gap: '12px', flex: 1 }}>
            <input placeholder="🔍 Buscar por placa, nome, cliente, serial ou modelo..." value={busca} onChange={e => setBusca(e.target.value)} style={{ ...inputStyle, width: '360px' }} />
            <select value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)} style={{ ...inputStyle, width: '160px' }}>
              <option value="todos">Todos</option>
              <option value="ativo">Ativos</option>
              <option value="inativo">Inativos</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => exportarTargetsPDF(targetsFiltrados, filtroStatus !== 'todos' ? (filtroStatus === 'ativo' ? 'Ativos' : 'Inativos') : null)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📄 Exportar PDF</button>
            <button onClick={() => exportarTargetsCSV(targetsFiltrados)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📥 Exportar Excel</button>
            <button onClick={() => setModalAberto(true)} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>+ Novo Target</button>
          </div>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f8f8' }}>
                {['Ícone', 'Placa', 'Nome', 'Tipo', 'Cliente', 'Equipamento', 'Status', 'Ações'].map(h => (
                  <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {targetsFiltrados.length === 0 ? (
                <tr><td colSpan="8" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>🚗</div>
                  <div>Nenhum veículo encontrado</div>
                </td></tr>
              ) : targetsFiltrados.map((t, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0', opacity: t.status === 'inativo' ? 0.6 : 1 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                  <td style={{ padding: '14px 16px', fontSize: '24px' }}>{t.icone}</td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '700', fontFamily: 'monospace' }}>{t.identificador}</td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500' }}>{t.nome}</td>
                  <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>{t.tipo}</td>
                  <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>
                    {t.cliente_nome || '—'}
                  </td>
                  <td style={{ padding: '14px 16px', fontSize: '12px', fontFamily: 'monospace', color: '#666' }}>
                    {t.equipamento_serial || '—'}
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{ background: t.status === 'ativo' ? '#E1F5EE' : '#f0f0f0', color: t.status === 'ativo' ? '#0F6E56' : '#666', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                      {t.status === 'ativo' ? '🟢 Ativo' : '⚪ Inativo'}
                    </span>
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => editar(t)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>✏️</button>
                      <button onClick={() => inativar(t)} style={{ background: t.status === 'ativo' ? '#FAEEDA' : '#E1F5EE', color: t.status === 'ativo' ? '#633806' : '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                        {t.status === 'ativo' ? '⏸' : '▶'}
                      </button>
                      <button onClick={() => deletar(t)} style={{ background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '600px', maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>{targetSelecionado ? '✏️ Editar Veículo' : '➕ Novo Veículo'}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={labelStyle}>Placa / Identificador *</label>
                <input style={inputStyle} value={form.identificador} onChange={e => setForm({ ...form, identificador: e.target.value.toUpperCase() })} placeholder="ABC-1234" />
              </div>
              <div>
                <label style={labelStyle}>Nome do Veículo *</label>
                <input style={inputStyle} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Ex: Corolla Branco 2022" />
              </div>
              <div>
                <label style={labelStyle}>Modelo</label>
                <input style={inputStyle} value={form.modelo} onChange={e => setForm({ ...form, modelo: e.target.value })} placeholder="Ex: Toyota Corolla" />
              </div>
              <div>
                <label style={labelStyle}>Tipo</label>
                <select style={inputStyle} value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
                  {TIPOS.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Ícone no mapa</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {ICONES.map(ic => (
                    <button key={ic} onClick={() => setForm({ ...form, icone: ic })} style={{
                      fontSize: '24px', padding: '8px', border: form.icone === ic ? '2px solid #1D9E75' : '2px solid #eee',
                      borderRadius: '8px', background: form.icone === ic ? '#E1F5EE' : 'white', cursor: 'pointer'
                    }}>{ic}</button>
                  ))}
                </div>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Cor do marcador (quando parado e desligado — em movimento fica verde, ligado fica amarelo, sem sinal fica cinza)</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  {CORES.map(c => (
                    <button key={c} onClick={() => setForm({ ...form, cor: c })} title={c} style={{
                      width: '32px', height: '32px', borderRadius: '50%', background: c, cursor: 'pointer',
                      border: form.cor === c ? '3px solid #333' : '2px solid #eee',
                      boxShadow: form.cor === c ? '0 0 0 2px white inset' : 'none'
                    }} />
                  ))}
                  <input
                    type="color"
                    value={form.cor || '#1D9E75'}
                    onChange={e => setForm({ ...form, cor: e.target.value })}
                    style={{ width: '36px', height: '32px', padding: '2px', border: '2px solid #eee', borderRadius: '8px', cursor: 'pointer' }}
                    title="Escolher outra cor"
                  />
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '50%', background: form.cor || '#1D9E75',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px',
                    border: '2px solid white', boxShadow: '0 1px 4px rgba(0,0,0,0.3)'
                  }}>{form.icone}</div>
                </div>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Cliente</label>
                <select style={inputStyle} value={form.cliente_id} onChange={e => setForm({ ...form, cliente_id: e.target.value })}>
                  <option value="">Selecione o cliente</option>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.nome_fantasia}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Equipamento GPS</label>
                <select style={inputStyle} value={form.equipamento_id} onChange={e => setForm({ ...form, equipamento_id: e.target.value })}>
                  <option value="">Selecione o equipamento</option>
                  {equipamentosDisponiveis.map(e => <option key={e.id} value={e.id}>{e.serial} — {e.modelo}</option>)}
                </select>
                {equipamentos.length !== equipamentosDisponiveis.length && (
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                    {equipamentos.length - equipamentosDisponiveis.length} equipamento(s) já vinculado(s) a outros veículos não são exibidos.
                  </div>
                )}
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Observações</label>
                <textarea style={{ ...inputStyle, height: '70px', resize: 'vertical' }} value={form.observacoes} onChange={e => setForm({ ...form, observacoes: e.target.value })} placeholder="Observações sobre o veículo..." />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={fecharModal} style={{ padding: '10px 20px', border: '1.5px solid #ddd', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '14px' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ padding: '10px 24px', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', cursor: salvando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : targetSelecionado ? 'Atualizar' : 'Salvar Veículo'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Targets;